export const extname = (filename: string) => filename?.split('.')?.pop()
